import { Vue } from 'vue-property-decorator';
import { formatTime as formatTimeInMilliSec } from '@/utils/date';
import { formatFullTime as formatTimeInMilliSecond } from '@/utils/date';

Vue.filter('formatTime', (timeInMilliSec: number) => {
    return formatTimeInMilliSec(timeInMilliSec);
});

Vue.filter('formatFullTime', (timeInMilliSec: number) => {
    return formatTimeInMilliSecond(timeInMilliSec);
});
